import * as Actions from 'src/_actions/cui'
import initialState from 'src/_store/initialState'

const cmdHistoryReducer = (state = initialState.cmd_history, action) => {
  switch (action.type) {
    case Actions.SET_CMD_HISTORY:
      return [...state, action.payload]
    // return state.command_history.concat(action.payload)
    case Actions.UPDATE_CLEAR:
      let data = Object.assign([], state)
      data.map(el => {
        el.is_cleared = true
      })
      return [...data]
    case Actions.UPDATE_SECRET:
      let data2 = Object.assign([], state)
      data2[data2.length - 1].is_secret_valid = true
      return [...data2]
    default:
      return state
  }
}
export default cmdHistoryReducer
